export default function TeamTopSection() {
    return (
        <div className="flex flex-col items-center justify-end w-full bg-gray-200 text-primary px-5 md:px-20 lg:px-32 py-16 md:py-18">
            <div className="flex flex-col items-center justify-center w-full">
                <h1 className="text-[32px] md:text-[42px] lg:text-[52px] font-bold text-center">
                    Our <span className="text-primary">Team</span>
                </h1>
                <p className="text-[16px] md:text-[18px] lg:text-[20px] text-center mt-4 md:mt-6 max-w-[600px]">
                    Meet our skilled professionals dedicated to delivering excellence and driving our shared vision forward.
                </p>
            </div>
        </div>
    );
}
